import {
  Component,
  Input,
  ViewContainerRef,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';
import { DefaultCellComponent } from '../table-cell/default-cell.component';

@Component({
  selector: 'dynamic-component',
  standalone: true,
  template: '<ng-container #container></ng-container>',
})
export class DynamicComponent implements OnInit {
  @Input() type!: string;
  @Input() data: any;
  @Input() componentMap!: { [key: string]: any };
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    // console.log(this.type);

    const componentType = this.getComponentType(this.type);
    const componentRef =
      this.viewContainerRef.createComponent<any>(componentType);
    componentRef.instance.data = this.data;
    componentRef.instance.rowData = this.rowData;
    componentRef.instance.type = this.type;
    if (componentRef.instance.cellClick) {
      componentRef.instance.cellClick.subscribe((data: any) =>
        this.cellClick.emit(data)
      );
    }
  }

  private getComponentType(typeName: string) {
    // console.log(this.componentMap[typeName]);

    if (!this.componentMap[typeName]) return DefaultCellComponent;
    else return this.componentMap[typeName];
  }
}
